import {Routes} from '../routing.config';
import {RouteKey} from '../routing.enums';
import isMatchRoute from './isMatchRoute';

function getRouteKey(path: string): RouteKey | null {
  const matchingRoutes = Object.entries(Routes)
    .filter(([_, routePath]) => isMatchRoute(routePath, path))
    .map(([routeKey, routePath]) => ({
      routeKey: routeKey as RouteKey,
      partsCount: routePath.split('/').filter((part) => part.length > 0).length,
    }));

  if (matchingRoutes.length === 0) {
    return null;
  }

  const [mostSpecific] = matchingRoutes.sort((a, b) => b.partsCount - a.partsCount);

  return mostSpecific.routeKey;
}

export default getRouteKey;
